import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class TimeAnalysisBarChart extends Vue {
  @Prop({ default: () => ([]) }) readonly columns: Array<any>
  @Prop({ default: () => ([]) }) readonly dataValue: any
  @Prop({ default: null }) index: number

  title = ''

  mounted() {
    this.init()
  }

  seriesDataItem(obj, color) {
    const data = []
    this.columns.forEach((item) => {
      if (item.key !== 'total') {
        data.push({ name: item.name, value: this.dataValue[item.key], itemStyle: { color: color[item.key] } })
      } else {
        this.title = item.name
      }
    })
    return data
  }

  init() {
    const color = {}
    this.columns.map(column => {
      color[column.key] = column.color
    })
    const seriesData = this.seriesDataItem(this.dataValue, color)
    // 基于准备好的dom，初始化echarts实例
    var myChart = (this as any).$echarts.init(
      this.$refs.myChart
    )
    const formatter = () => {
      return `${this.title}\r\n${this.dataValue.total}`
    }
    const rendLegend = (text) => {
      let num = 0
      this.columns.map(item => {
        if (item.name === text) {
          num = this.dataValue[item.key]
          return text + num
        }
      })
    }
    // 指定图表的配置项和数据
    var option = {
      title: {
        show:false
      },
      tooltip: {
        show: true,
        trigger: 'item'
      },
      legend: {
        top: '30%',
        right: '200',
        orient: 'vertical',
        // formatter: rendLegend
      },
      series: [
        {
          type: 'pie',
          radius: ['60%', '80%'],
          // center: ['40%', '50%'],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          label: {
            normal: {
              show: true,
              position: 'center',
              formatter: formatter(),
              textStyle: {
                fontSize: 18,
                lineHeight: 20,
                color: '#4a90e2'
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          },
          data: seriesData
        }
      ]
    }
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option)
  }

  render() {
    return (
      <div ref="myChart" style={{ width: '100%', height: '228px' }}></div>
    )
  }
}
